import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import 'react-dropdown-tree-select/dist/styles.css'
import { SERVER_IP, PORT, PORT_webRTC, ud, jwt, logout } from '../../Server'
import swal from 'sweetalert';
import axios from 'axios';
import honeywell from '../../assets/images/honeywell_w.png'

var styleGrid;
class CallInitiation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            to_caller_list: this.props.to_calling_obj.callers,
            call_type: this.props.to_calling_obj.call_type,
        }
    }
    componentDidMount() {
        this.setState({ to_caller_list: this.props.to_calling_obj.callers })
        this.callInitiationApi(this.props.to_calling_obj.call_type, this.props.to_calling_obj.call_format, this.props.to_calling_obj.callers);
        styleGrid = {
            gridTemplateColumns: `repeat(${this.props.to_calling_obj.callers.length}, 1fr)`,
            gridGap: "1rem",
            gridTemplateRows: `repeat(${Math.floor((this.props.to_calling_obj.callers.length) / 4) == 0 ? 1 : Math.floor((this.props.callers.length) / 4)}, fr)`
        }
        return

    }
    callInitiationApi = (call_type, call_format, callers) => {
        let clr_obj = []
        callers.map(list => clr_obj.push(list.user_id))
        if (clr_obj.length == 0) {
            return
        }
        const deviceinfo = callers[0]?.devices[0];
        let headers = {
            'Content-Type': 'application/json',
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        const data = {
            from_id: ud.id,
            from_user_name: ud.username,
            from_user_email: ud.email,
            from_session_id: ud.session_id,
            to_id: clr_obj,
            call_type,
            call_format,
            devicetype: "WebBrowser",
            deviceinfo: deviceinfo
        }
        var _this = this;
        var new_Callers = []
        axios.post(`${SERVER_IP}/callInitiate`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error) {
                    if (response.data.acess === "acess-denied") {
                        // logout.logout();
                        return
                    }
                }
                if (response.data.error === false) {
                    _this.props.updateRoomId(response.data.room_id);
                    _this.props.to_calling_obj.callers.map((list, index) => {

                        if (response.data.users_status.find(raw => raw.user_id === list.user_id && raw.user_flag_name != "DND")) {
                            new_Callers.push(list)
                        }
                    })
                    _this.setState({ to_caller_list: new_Callers })
                    _this.props.updateCallers(new_Callers);
                } else {
                    swal(response.data.flag_name);
                    _this.props.callError();
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong,Please Retry")
            });
    }
    onChangeInput = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
    callDecline = () => {
        this.props.callDecline("SELF")

    }
    render() {

        return (
            <div>
                <div className="calling_window" style={{ zIndex: "999" }}>

                    <div className="calling_app-wrapper">

                        {/* add people */}
                        <div className="add_ppl text-center">
                            <button type="button" class="btn btn-round btn-light"><i class="mdi mdi-account-plus"></i> </button>
                            <p className="mt-1">Add people</p>
                        </div>


                        {/* Caller info */}

                        <div className="caller_info_grid" style={styleGrid}>
                            {this.state.to_caller_list.map(list =>
                                <div className="caller_info">
                                    <div className="profile_avatar text-center">
                                        <img src="https://picsum.photos/300/300" alt="user-profile" className="rounded-circle img-thumbnail  img-fluid" width="150px" />
                                        <p className="user-name mt-2">{list.user_name}</p>
                                    </div>
                                </div>
                            )}
                        </div>



                        {/* calling option */}

                        <div className="calling_opt">
                            <ul className="m-0">
                                <li>
                                    <button className="btn btn-light btn-round text-dark">
                                        <i className="mdi mdi-microphone" data-toggle="tooltip" title="On microphone"></i>
                                        {/* mdi mdi-microphone-off */}
                                    </button>

                                    <button className="btn btn-danger btn-round ml-3" onClick={this.callDecline} data-toggle="tooltip" title="Leave call" ><i className="mdi mdi-phone-hangup"></i></button>

                                    <button className="btn btn-light btn-round ml-3 text-dark" data-toggle="tooltip" title="Open camera"><i className="mdi mdi-video-off"></i>
                                        {/* mdi mdi-video */}
                                    </button>
                                </li>
                            </ul>
                            {/* <button className="btn ml-2" data-toggle="tooltip" title="Leave call"><i className="mdi mdi-phone-hangup"></i></button> */}
                        </div>

                        {/* logo */}
                        <div className="brand_logo">
                            <img src="/static/media/gailLogo.b4f56557.png" className="img-fluid" alt="logo"></img>
                        </div>

                        <div className="h-logo">
                            <img src={honeywell} className="img-fluid" alt="logo"></img>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default CallInitiation;
